(ns teamoesterreich.admin-mode.modal.toe-search
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.admin-mode.data.user :as s-user]
            [reagent.core :as r]))




(defn result-line [[uuid tomId name phone email] on-select-cb]
  [mui/grid
   {:item true :xs 12}
   [mui/paper {:style {:height "38px" :padding "4px" :marginBottom "4px"}}
    [:span {:style {:padding "5px" :fontSize "14"}} (str tomId ") " name)]
    [mui/button {:color   "secondary" :style {:float "right"}
                 :onClick (fn [] (on-select-cb tomId))
                 } "auswählen"]
    ]])



(defn get-modal [!show on-select-cb]
  (let [!st (r/atom {:search nil :result nil :input ""})
        !input (r/cursor !st [:input])
        !search (r/cursor !st [:search])
        !result (r/cursor !st [:result])

        close-fn (fn []
                   (reset! !show nil)
                   (swap! !st assoc :search nil :result nil :input ""))
        on-select-cb (fn [e]
                       (on-select-cb e)
                       (close-fn)
                       )
        ]
    (fn []
      (when (and @!search (nil? @!result))
        (s-user/>search-user @!input
                            (fn [res]
                              (println "GOT!:" (clj->js res))
                              (swap! !st assoc
                                     :search nil :result res))))
      [mui/modal
       {:aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (not (nil? @!show))
        :onClose          close-fn
        }
       (cond
         ;searching
         (and @!search (nil? @!result))
         [:div
          {:class "modal"
           :style {:width 600}}
          [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
          [mui/typography "Suche ... "]
          [:br]
          [mui/button
           {:variant  "contained"
            :on-click close-fn
            }
           "Schließen"]
          ]
         ;input search
         (and (nil? @!search) (nil? @!result))
         [:div
          {
           :class "modal"
           :style {:width 400}}
          [:h4 "Personen suche"]
          [mui/text-field {:readOnly  true
                           :fullWidth true
                           :onChange  #(reset! !input (h/event-value %))
                           :variant   "outlined"
                           :label     "Suchtext Name/TomId"}]
          [:br]
          [:br]
          [mui/button
           {:variant "contained"
            :onClick close-fn
            }
           "Schließen"]
          [mui/button
           {:variant "contained"
            :style   {:float "right"}
            :color   "secondary"
            :onClick #(reset! !search true)
            }
           "Suchen"]]
         @!result
         ;search result
         [:div
          {
           :class "modal"
           :style {:width 400}}
          [:h4 "Ergebnis gefunden:" (:count @!result)]
          [mui/grid
           {:container true
            :direction "row"
            :justify   "flex-start"}
           (for [line (:result @!result)]
             ^{:key (str "result_block_" (second line))}
             [result-line line on-select-cb])]
          [mui/button
           {:variant "contained"
            :onClick (fn [] (swap! !st assoc :search nil :result nil))
            }
           "Zurück"]
          [mui/button
           {:variant "contained"
            :style   {:float "right"}
            :onClick close-fn
            }
           "Schließen"]
          ]
         )]
      )))

